document.addEventListener('DOMContentLoaded', function onReady() {
  
  // Track if we've already equalized thumbnail icons globally (once per page load)
  let thumbnailIconsEqualized = false;
  
  // Simple one-time equalization of thumbnail icons grouped by collection grid or dropdown menus
  function equalizeProductThumbnailIcons() {
    if (thumbnailIconsEqualized) return; // Only run once per page load
    
    // Only resize on screen sizes 768px and above
    if (window.innerWidth < 768) return;
    
    const collectionGrids = document.querySelectorAll('.yv-collection-product-grid, .yv-dropdown-menus, .row');
    if (!collectionGrids.length) return;
    
    // Process each collection grid/dropdown menu separately
    collectionGrids.forEach(grid => {
      const items = grid.querySelectorAll('.product-thumbnail-icons');
      if (!items.length) return;
      
      // Reset all heights in this grid to measure natural height
      items.forEach(el => { el.style.height = 'auto'; });
      
      // Find the tallest one in this grid
      let maxHeight = 0;
      items.forEach(el => {
        const height = el.offsetHeight;
        if (height > maxHeight) maxHeight = height;
      });
      
      // Set all items in this grid to the same height
      if (maxHeight > 0) {
        items.forEach(el => { 
          el.style.height = maxHeight + 'px'; 
        });
      }
    });
    
    thumbnailIconsEqualized = true; // Mark as done
  }

  // Simple product card height equalization for sliders only
  function equalizeProductCardHeights() {
    const sliders = document.querySelectorAll('.flickity-slider');
    
    sliders.forEach(slider => {
      const cards = slider.querySelectorAll('.yv-product-card');
      if (cards.length <= 1) return;
      
      // Reset heights
      cards.forEach(card => { card.style.height = 'auto'; });
      
      // Find tallest
      let maxHeight = 0;
      cards.forEach(card => {
        const height = card.offsetHeight;
        if (height > maxHeight) maxHeight = height;
      });
      
      // Apply to all
      if (maxHeight > 0) {
        cards.forEach(card => {
          card.style.height = maxHeight + 'px';
        });
      }
    });
  }

  // Set testimonial slider items to 100% height
  function setTestimonialItemsFullHeight() {
    const testimonialItems = document.querySelectorAll('.flickity-slider .yv-testimonial-slider-item');
    testimonialItems.forEach(item => {
      item.style.height = '100%';
    });
  }

  // Run initial equalization with delays for late-loading content
  setTimeout(() => {
    equalizeProductThumbnailIcons(); // Once only
    equalizeProductCardHeights();
    setTestimonialItemsFullHeight(); // Set testimonials to 100% height
  }, 500);
  
  setTimeout(() => {
    equalizeProductCardHeights(); // Cards again after more content loads
    setTestimonialItemsFullHeight(); // Ensure testimonials are still 100% height
  }, 1500);

  // Re-equalize cards and handle icon resizing based on screen size
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      equalizeProductCardHeights();
      
      // Reset thumbnail icons equalization flag and handle based on screen size
      thumbnailIconsEqualized = false;
      
      if (window.innerWidth < 768) {
        // Reset icon heights to auto on smaller screens
        const iconElements = document.querySelectorAll('.product-thumbnail-icons');
        iconElements.forEach(el => { el.style.height = 'auto'; });
      } else {
        // Re-equalize icons on larger screens
        equalizeProductThumbnailIcons();
      }
    }, 300);
  });

});